@if (permissionsArray$ | async; as permissionsArray) {
  <button
    type="button"
    mat-mini-fab
    color="primary"
    [matMenuTriggerFor]="permissionsList"
    (menuOpened)="opened()"
    matTooltip="Toggle security preview"
    [matTooltipShowDelay]="1000"
    [matTooltipHideDelay]="2000"
  >
    <mat-icon>lock</mat-icon>
  </button>
  <mat-menu
    #permissionsList="matMenu"
    [overlapTrigger]="false"
    [hasBackdrop]="true"
    xPosition="before"
    yPosition="above"
  >
    @if (caseData$ | async; as caseContext) {
      <mat-list dense (click)="$event.stopPropagation()">
        @if (caseContext?.caseType) {
          <mat-list-item>
            <mat-icon matListIcon>group_work</mat-icon>
            <span matList>{{ caseContext?.caseType.friendlyId }}</span>
            @if (!caseContext?.caseType) {
              <mat-list-item><mat-icon>group_work_off</mat-icon>No Opinion Type</mat-list-item>
            }
          </mat-list-item>
        }
      </mat-list>
    } @else {
      <mat-list dense (click)="$event.stopPropagation()">
        <mat-list-item>
          <mat-icon matListIcon>group_work_off</mat-icon>
          <span matLine>No context</span>
        </mat-list-item>
      </mat-list>
    }
    <mat-divider></mat-divider>
    <mat-list dense (click)="$event.stopPropagation()">
      @for (perm of permissionsArray; track perm) {
        <mat-list-item>
          <mat-icon matListIcon inline>{{
            perm.indexOf("hide") > 0 ? "visibility_off" : "visibility"
          }}</mat-icon>
          <span>{{ perm }}</span>
        </mat-list-item>
      }
      @if (permissionsArray.length === 0) {
        <mat-list-item>
          <mat-icon matListIcon>visibility_off</mat-icon>
          <span matLine>No permissions</span>
        </mat-list-item>
      }
    </mat-list>
  </mat-menu>
}
